import Box from '@mui/material/Box';
import { Article } from 'functions/src/types/firestore/Game/Article';
import { ArticleListItemMobile } from './ArticleListItemMobile';
import { ReactGlider } from '../ReactGlider';
import { useDateFormatter } from 'src/hooks/useDateFormatter';
import { ARTICLE_DATE_FORMAT } from './ArticleListItem';
import { NUMERIC_NOTIMEZONE } from 'src/util/dates/presets/times';

export type ArticleCarouselMobileProps = { articles: Article<Date>[] };

export function ArticleCarouselMobile({
  articles,
}: ArticleCarouselMobileProps) {
  const format = useDateFormatter({
    dateFormat: ARTICLE_DATE_FORMAT,
    timeFormat: NUMERIC_NOTIMEZONE,
    separator: ', ',
  });
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      <ReactGlider
        itemWidth={376}
        hasArrows={false}
        formatContainer={true}
        trackStyle={{ maxWidth: `${articles.length * 400}px !important` }}
        navGradientColor={'primary.verticalInverse'}
      >
        {articles.map((article) => {
          const { id, date, description } = article;
          const dateFormatted = format(date);
          return (
            <Box sx={{ p: 2 }} key={`slide-${id}${description}`}>
              <ArticleListItemMobile
                dateFormatted={dateFormatted}
                {...article}
              />
            </Box>
          );
        })}
      </ReactGlider>
    </Box>
  );
}
